import { Module } from 'vuex';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';
import { AdminState } from './types';
import { RootState } from '../types';

export const state: AdminState = {
    users: [],
    selectedUser: null,
    selectedModel: null,
    models: [],
    logins: [],
    scenarioStatus: [],
    selectedScenario: null,
    loginEditing: {
        displayName: '',
        email: '',
    },
    groups: [],
    selectedGroup: null,
    groupUsers: [],
    modelGroups: [],
    modelRoles: [],
    globalRoles: [],
    selectedRole: null,
    roleGroups: [],
    roleModelGroups: [],
    isAddingGroup: false,
    isAddingLogin: false,
    userAccess: null,
    usageStats: null,
    usageUsers: [],
    usageModels: [],
};

const namespaced = true;

export const admin: Module<AdminState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
